// Global constants for the application
export const BUSINESS_NAME = 'jeebon';
export const BUSINESS_NAME_CAPITALIZED = 'Jeebon';

// Get version from package.json or git tag
export const APP_VERSION = '0.2.0'; // This will be replaced with dynamic version
